import { Box, Divider, Link } from "@vapor/react-material";
import { FooterDto } from "../../dtos/FooterDto";
import Typography from "@vapor/react-extended/ExtendedTypography";

const Footer = (props: FooterDto) => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            sx={{
                display: "flex",
                gap: "0.5rem",
                justifyContent: "center",
            }}
        >
            <Typography variant="body">© {currentYear} TeamSystem Service</Typography>
            <Divider
                flexItem
                orientation="vertical"
                variant="middle"
            />
            <Link
                href={props.privacyPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
            >
                Privacy Policy
            </Link>
            <span>·</span>
            <Link
                href={props.cookiePolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
            >
                Cookie
            </Link>
        </Box>
    );
};

export default Footer;
